<script lang="ts" setup>
</script>

<template>
  <a>
    <slot />
  </a>
</template>